import { throwError as observableThrowError, Observable, throwError, EMPTY } from 'rxjs';
import { catchError, retry, switchMap, takeWhile } from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse, HttpHeaders  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  ModalService } from '@ibe/services/ui';
import { INDRASessionTimeoutModalComponent } from '@ibe.components/shared/session-timeout-modal/session-timeout-modal.indra.component';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { Router } from '@angular/router';
import { RETRIES_ON_401 } from '@ibe.config';
import { Store } from '@ngrx/store';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import * as UserActions from '@ibe/store/actions/user.actions';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as fromStore from '../store';

import { PAYMENT_APIS_NO_RETRY } from '@ibe.config';


@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {
	
	private user_info$: Observable<any> = this.store.select(fromStore.getUserInfo);
	private userInfo;
	private isAlive = true;
	
	constructor(
		private modalService: ModalService,
		private api: INDRAApiService,
		private router: Router,
		private store: Store<fromStore.State>,
		private storage: INDRAStorageService
	) {
		this.user_info$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.userInfo = value;
			});
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		
		// check first if API URL is excluded for retry
		let excludedAPIsForRetry = false;
		if (req && req.url) {
			for (let i=0; i < PAYMENT_APIS_NO_RETRY.length; i++) {
				if (req.url.includes(PAYMENT_APIS_NO_RETRY[i])) {
					excludedAPIsForRetry = true;
					break;
				}
			}
		}
		
		if (excludedAPIsForRetry) {
			return next.handle(req).pipe(
				catchError((error) => {
					if (error instanceof HttpErrorResponse) {
						if (error.status == 401) {
							this.api.clearSessionToken();
							this.modalService.close();
							this.modalService.assignComponent(INDRASessionTimeoutModalComponent);
								this.modalService.open();
						} else {
							return throwError(error);
						}
					}
					return EMPTY;
				})
			);
		} else {
			return next.handle(req)
				.pipe(retry(1),
				catchError((error) => {
					if (error instanceof HttpErrorResponse) {
						// upon retry of api call if still 401 open session-timeout-modal
						if (error.status == 401) {
							if (RETRIES_ON_401 && (this.router.url === '/booking' || this.router.url === '/')) {
								// only applicable on search page
								this.clearUserData();
								return this.handle401Error(req, next);
							} else {
								this.api.clearSessionToken();
								this.modalService.close();
								this.modalService.assignComponent(INDRASessionTimeoutModalComponent);
								this.modalService.open();
							}
						} else {
							return throwError(error);
						}
					}
					return EMPTY;
				}),
			);
		}
	}

	handle401Error(req: HttpRequest<any>, next: HttpHandler) {
		return this.api.INDRA_retrieveNewToken().pipe(
			retry(RETRIES_ON_401),
			switchMap((newToken: any) => {
				if (newToken) {
					/*
					if (this.userInfo) {
						this.callAutomaticLogin();
					}
					*/
					const newReq = req.clone({
						setHeaders: {
							Authorization: `Bearer ${newToken}`
						}
					});
					return next.handle(newReq);
				}
			}),
			catchError(() => {
				return EMPTY;
			})
		)
	}
	
	private async callAutomaticLogin() {
		await this.automaticLogin();
	}
	
	// automatically logs in the currently logged in user in case there is a 401 error from the API
	// if login fails, clear user data
	private automaticLogin() {
		return new Promise(resolve => {
			
			const loginRequest = {
				flyTapLogin: true,
				flyTapToken: this.userInfo.flyTapLogin,
				customerId: this.userInfo.airlineID
			};
			
			this.api.INDRA_automaticLogin(loginRequest).subscribe((res: any) => {
        const {otp} = res;
				if (res.status == '200' && res.data) {
					const { userProfile, userPnrs, translate, userAddress, defaultCurrency} = res.data;
					const userData = {
						...userProfile,
						userPnrs: userPnrs,
						userAddress: userAddress,
						translate: translate,
						userProfile: userProfile,
            otp
					};
					this.storage.set('userData', userData);
					const userInfo = { ...userProfile, defaultCurrency};
					this.store.dispatch(new UserActions.PutLoggedInAction(true));
					this.store.dispatch(new UserActions.PutUserInfoAction(userInfo));
				} else {
					this.clearUserData();
				}
				resolve(true);
			}, error => {
				this.clearUserData();
				resolve(true);
			});
		});
	}
	
	private clearUserData() {
		this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
		this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
		this.store.dispatch(new UserActions.PutLoggedInAction(false));
		this.store.dispatch(new UserActions.PutUserInfoAction(false));
		this.store.dispatch(new UserActions.PutCancelLogIn(false));
		this.storage.remove('userData');
		this.storage.remove('user_info');
	}
}
